import React, { Component } from 'react';
import { Row, Col, Card, CardBody, Input } from 'reactstrap';
import ReactPaginate from 'react-paginate';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import lodash from 'lodash'; // library added for debounce functionality


class SalesReportDataTableFM extends Component {
  state = {
    controls: {
      search: {
        value: '',
        valid: null,
        touched: false,
        nullValue: null
      }
    }
  }

  constructor(props) {
    super(props);
    this.searchFleetFm = lodash.debounce(this.searchFleetFm, 500);
  }

  handleInputChange = (e) => {
    const controlName = e.target.name;
    const controlValue = e.target.value;
    const { controls } = this.state;
    controls[controlName].value = controlValue;
    this.setState({ controls });
    this.searchFleetFm(controlValue);
    // this.handleValidation();
  }

  searchFleetFm = (search) => {
    this.props.searchFleetSalesFm(search);
  }

  render() {
    const { controls } = this.state;
    const { search } = controls;
    return (
      <div>
        <Row>
          <Col sm="4">
            <Input
              type="text"
              name="search"
              id="search"
              placeholder="Enter Member Code or Fleet Name"
              className="login-input"
              value={search.value}
              onChange={this.handleInputChange}
            />
            <div>
              <img src="images/search.svg" className="report-search" alt='search'></img>
            </div>
          </Col>
          {this.props.fleetSalesFM && this.props.fleetSalesFM.sales && this.props.fleetSalesFM.sales.length > 0 && <Col>
            <span className="Download-Full-Report pull-right" onClick={(e) => this.props.getFleetSalesFM(null, null, true, search.value)} style={{ cursor: 'pointer' }}>Download Full Report</span>
          </Col>}
        </Row>
        <Card className="c-top-15">
          <CardBody>
            <table className="table table-bordered table-responsive">
              <thead style={{ background: '#f6f6f6' }}>
                <tr>
                  <th className="sales-report-th text-center">Member Code</th>
                  <th className="sales-report-th text-center">Fleet Name</th>
                  <th className="sales-report-th text-center">Location</th>
                  <th colSpan="2" className="sales-report-th text-center">Direct Sales</th>
                  {/* <th colSpan="2" className="sales-report-th">Indirect Sales</th> */}
                  {/* <th colSpan="2" className="sales-report-th text-center">Total</th> */}
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td colSpan="3" />
                  <td className="sales-report-th">TBR Qty.</td>
                  <td className="sales-report-th">TBB Qty.</td>
                  {/* <td className="sales-report-th">TBR Qty.</td>
                  <td className="sales-report-th">TBB Qty.</td> */}
                  {/* <td className="sales-report-th">TBR</td>
                  <td className="sales-report-th">TBB</td> */}
                </tr>

                {
                  (this.props.fleetSalesFM.sales || []).map((sale) => (
                    <tr key={sale.uuid}>
                      <td onClick={(e) => this.props.goToMemberSalesReport(sale)} className="capital-case sales-report-td" style={{ color: '#545cd8', cursor: 'pointer' }}>
                        {sale.member_id}
                      </td>
                      <td className="title-case sales-report-td">{sale.business_name}</td>
                      <td className="title-case sales-report-td">{sale.region_name}</td>
                      <td className="sales-report-td">{sale.direct_tbr}</td>
                      <td className="sales-report-td">{sale.direct_tbb}</td>
                      {/* <td className="sales-report-td">{sale.indirect_tbr}</td>
                      <td className="sales-report-td">{sale.indirect_tbb}</td> */}
                      {/* <td className="sales-report-td">{sale.total_tbr}</td>
                      <td className="sales-report-td">{sale.total_tbb}</td> */}
                    </tr>
                  ))
                }
              </tbody>
            </table>

            {this.props.fleetSalesFM.total_count > 10 && <div className="pull-right" style={{ display: 'flex', marginTop: '10px' }}>
              <span style={{ marginTop: '7px' }}>
                <span className="showing">Showing </span>
                <span className="showing-page">
                  {`${this.props.fleetSalesFM.page - 1}1`}
                  -{(((this.props.fleetSalesFM.page - 1) * 10) + (this.props.fleetSalesFM.sales || []).length) < 10 ? '0' : ''}{(((this.props.fleetSalesFM.page - 1) * 10) + (this.props.fleetSalesFM.sales || []).length)}
                  &nbsp;of {this.props.fleetSalesFM.total_count < 10 ? '0' : ''}{this.props.fleetSalesFM.total_count}
                </span>
              </span>
              &nbsp;&nbsp;&nbsp;
              <ReactPaginate
                previousLabel={<FontAwesomeIcon icon={faChevronLeft} />}
                nextLabel={<FontAwesomeIcon icon={faChevronRight} />}
                breakLabel="..."
                breakClassName="break-me"
                pageCount={this.props.fleetSalesFM.pageCount}
                // pageCount={18}
                marginPagesDisplayed={2}
                pageRangeDisplayed={3}
                onPageChange={this.props.handlePageClick.bind(this, search.value)}
                containerClassName="pagination"
                subContainerClassName="pages pagination"
                pageLinkClassName="c-page"
                previousLinkClassName="c-prev"
                nextLinkClassName="c-next"
                breakLinkClassName="c-break-line"
                activeClassName="active"
                activeLinkClassName="c-page-link"
              />
            </div>}

          </CardBody>
        </Card>
      </div >
    );
  }
}

export default SalesReportDataTableFM;